export default {
  tracking_id: "G-EV19NNQ22Q",
};
